// @flow

import * as React from 'react'

type Props = { className?: string }

export const StopIcon = React.forwardRef<Props, any>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    className={props.className}
    ref={ref}
  >
    <g fill="none" fillRule="evenodd">
      <rect width={36} height={36} fill="#e87161" rx={18} />
      <rect width={14} height={14} x={11} y={11} fill="#fff" rx={1.5} />
    </g>
  </svg>
))
